import { Component, OnInit, HostBinding } from '@angular/core';
import { DataAccess } from '../../data-access/services/data-access.service';
import { BmGrid } from '../../grid/classes/bm-grid';
import { RowClickedEvent } from '@ag-grid-community/all-modules';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'bm-tree-editor',
  templateUrl: './tree-editor.component.html',
  styleUrls: ['./tree-editor.component.scss']
})
export class TreeEditorComponent implements OnInit {

  rowData: any[] = [];
  columnDefs = [];
  modules = BmGrid.modules;
  editorForm: FormGroup;
  actionAutocomplete$: Observable<string[]>;
  submitted = false;

  @HostBinding('style.width')
  width = '100%';

  @HostBinding('style.height')
  height = '100%';

  constructor(private dataAccess: DataAccess, private builder: FormBuilder) {}

  clear() {
    this.editorForm.reset();
    this.submitted = false;
  }

  handleRowClick(event: RowClickedEvent) {
    this.editorForm.setValue({...event.data, newId: event.data.id});
  }

  handleSave() {
    this.submitted = true;

    if (this.editorForm.invalid) {
      return;
    }

    const {action: actionToSet} = this.editorForm.value;

    this.dataAccess.execute('UpdateSettingTree', {
      actionToSet,
      ...this.editorForm.value,
    }).then(({data}) => {
      this.fillGrid(data);
    });
  }

  fillGrid(data) {
    this.rowData = data[0];
    this.columnDefs = Object.keys(data[0][0]).map(key => {
      return {field: key};
    });
  }

  ngOnInit() {
    this.dataAccess.execute('GetListOfMethods').then(({data}) => {
      this.actionAutocomplete$ = this.editorForm.get('action').valueChanges.pipe(
        startWith(''),
        map(value => {
          if (value === null) {
            value = '';
          }
          return data[0].map(obj => obj.action).filter(action => action.toLowerCase().includes(value.toLowerCase()));
        })
      );
    });

    this.dataAccess.execute('SettingTree').then(({data}) => this.fillGrid(data));

    this.editorForm = this.builder.group({
      id: [],
      newId: [, [Validators.required]],
      parentId: [, [Validators.required]],
      name: [, [Validators.required]],
      tooltip: [, [Validators.required]],
      userPermission: [, [Validators.required]],
      action: [],
      openWith: [],
      formName: [],
      permissionBrandId: [],
      isActive: [, [Validators.required]],
    });
  }

}
